<template>
  <ul class="clearfix">
    <li
      @click="handleBook(book, index)"
      v-for="(book, index) in booklist"
      class="fl recommendItem f-pr"
      :key="index"
    >
      <!-- <router-Link :to="'/bookdetail/' + book.book.id"> -->
      <img
        v-lazy="book.book.iconUrl"
        width="274"
        height="364"
        class="coverImg"
        :alt="book.book.name"
      />
      <div class="bookDetail">
        <div class="booksuo">
          <h4 class="bookName" :title="book.book.name">
            {{ book.book.name }}
          </h4>
          <img v-if="index !=0 && suoShow" :src="suo" alt="" />
        </div>
        <a href="#" class="author" v-if="book.book.author != undefined">
          {{ book.book.author.name }}
        </a>
        <div class="bookSort">
          <a href="javaScript"> {{ book.book.sort }} <span>|</span> </a>
          <em>{{ book.book.finished ? "已完结" : "连载中" }}</em>
          <!--                          <div>{{book.book.clickNum}}</div>-->
        </div>
        <p class="summary">
          {{ book.book.introduce }}
        </p>
      </div>
      <!-- </router-Link> -->
    </li>

    <!--      <template v-if="book.book">-->
    <!--        <dl class="main-dl clearfix">-->
    <!--          <dt class="fl">-->
    <!--            <router-Link :to="'/bookdetail/' + book.book.id"-->
    <!--              ><img-->
    <!--                v-lazy="book.book.iconUrl"-->
    <!--                width="120"-->
    <!--                height="168"-->
    <!--                :alt="book.book.name"-->
    <!--              />-->
    <!--            </router-Link>-->
    <!--          </dt>-->
    <!--          <dd class="main-dd fr">-->
    <!--            <div>-->
    <!--              <router-Link :to="'/bookdetail/' + book.book.id" target="_blank">-->
    <!--                <h4 :title="book.book.name">{{ book.book.name }}</h4>-->
    <!--              </router-Link>-->
    <!--              <a href="#" class="author" v-if="book.book.author != undefined">{{-->
    <!--                book.book.author.name-->
    <!--              }}</a>-->
    <!--              <div class="flex">-->
    <!--                <a href="javaScript" target="_blank">-->
    <!--                  <em>{{ book.book.sort }}</em>-->
    <!--                </a>-->
    <!--                &lt;!&ndash; <span style="margin: 0 3px">|</span>-->
    <!--                <a href="javaScript:" class="name" target="_blank">-->
    <!--                  <em>{{ book.book.words }}字</em>-->
    <!--                </a> &ndash;&gt;-->
    <!--                <span style="margin: 0 3px">|</span>-->
    <!--                <em>{{ book.book.finished ? "已完结" : "连载中" }}</em>-->
    <!--              </div>-->
    <!--              <p class="summary">-->
    <!--                {{ book.book.introduce }}-->
    <!--              </p>-->
    <!--            </div>-->
    <!--          </dd>-->
    <!--        </dl>-->
    <!--      </template>-->
    <!--      <template v-else>-->
    <!--        <dl class="main-dl clearfix">-->
    <!--          <dt class="fl">-->
    <!--            <router-Link :to="'/bookdetail/' + book.bookId"-->
    <!--              ><img-->
    <!--                v-lazy="book.imgUrl"-->
    <!--                width="120"-->
    <!--                height="168"-->
    <!--                alt="book.name"-->
    <!--              />-->
    <!--            </router-Link>-->
    <!--          </dt>-->
    <!--          <dd class="main-dd fr">-->
    <!--            <div>-->
    <!--              <router-Link :to="'/bookdetail/' + book.bookId" target="_blank">-->
    <!--                <h4 :title="book.name">{{ book.name }}</h4>-->
    <!--              </router-Link>-->
    <!--              <a href="#" class="author" v-if="book.author != undefined">{{-->
    <!--                book.author.name-->
    <!--              }}</a>-->
    <!--              <div class="flex">-->
    <!--                <a href="javaScript" target="_blank">-->
    <!--                  <em>{{ book.sort }}</em>-->
    <!--                </a>-->
    <!--                <span style="margin: 0 3px">|</span>-->
    <!--                <a href="javaScript:" class="name" target="_blank">-->
    <!--                  <em>{{ book.words }}字</em>-->
    <!--                </a>-->
    <!--                <span style="margin: 0 3px">|</span>-->
    <!--                <em>{{ book.finished ? "已完结" : "连载中" }}</em>-->
    <!--              </div>-->
    <!--              <p class="summary">-->
    <!--                {{ book.introduce }}-->
    <!--              </p>-->
    <!--            </div>-->
    <!--          </dd>-->
    <!--        </dl>-->
    <!--      </template>-->
  </ul>
</template>

<script>
import suo from "../../assets/suo.png";
import { useInfoApi } from "@/api/login";
export default {
  props: {
    booklist: Array,
  },
  data() {
    return {
      suo: suo,
      suoShow: true,
    };
  },
  mounted() {
    if (sessionStorage['info']) {
      if (
        JSON.parse(sessionStorage.info).data.vip_expired_at == null ||
        +new Date(JSON.parse(sessionStorage.info).data.vip_expired_at) <
          +new Date()
      ) {
        this.suoShow = true;
      } else this.suoShow = false;
    }
    console.log(this.suoShow,'suoShow');
  },
  methods: {
    handleBook(val, idx) {
      console.log(idx, "idx");
      if (idx ==0) {
        this.$router.push({
          path: "/bookdetail/" + val.book.id,
        });
      } else {
        useInfoApi().then((res) => {
          if (res.code == 4010) {
            this.$emit("handleLogin", true);
          } else {
            if (
              res.data.vip_expired_at == null ||
              +new Date(res.data.vip_expired_at) < +new Date()
            ) {
              this.$emit("handleOpen");
            } else {
              this.$router.push({
                path: "/bookdetail/" + val.book.id,
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.booksuo{
  display: flex;
  align-items: center
  img{
    width 20px
    height 20px
    margin: 14px 0 0 10px
  }
}
</style>
